import React from 'react'
import { useTranslation } from 'react-i18next'

import './pattern-focus.styles.scss'

const PatternFocus = ({ patterns, productType, ...otherProps }) => {
  const { t } = useTranslation('updatedBAB')

  const firstPattern = patterns[0]

  const focusCloseHandler = (event) => {
    const targetElement = event.target
    let wrapper = targetElement.closest('.focus-wrapper')
    wrapper.removeAttribute('data-open')
  }

  return (
    <div className='focus-wrapper'>
      <div className='focus-container'>
        <div className='focus-close' onClick={focusCloseHandler}>
          <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M1 1L19 19' />
            <path d='M19 1L1 19' />
          </svg>
        </div>
        {productType === 'pants' ? (
          <img
            className='focus-image'
            src={`${firstPattern.imageSources.pants}?height=480`}
            alt={t(firstPattern.translationKeys.imageAlt.pants)}
            width='540'
            height='480'
            loading='lazy'
          />
        ) : (
          <img
            className='focus-image'
            src={`${firstPattern.imageSources.diapers}?height=480`}
            alt={t(firstPattern.translationKeys.imageAlt.diapers)}
            width='540'
            height='480'
            loading='lazy'
          />
        )}

        <p className='focus-name'>{t(firstPattern.translationKeys.name)}</p>
      </div>
      <div className='focus-overlay' onClick={focusCloseHandler} />
    </div>
  )
}

export default PatternFocus
